import { render, staticRenderFns } from "./MyUploadTab.vue?vue&type=template&id=6a10d600&scoped=true&"
import script from "./MyUploadTab.vue?vue&type=script&lang=js&"
export * from "./MyUploadTab.vue?vue&type=script&lang=js&"
import style0 from "./MyUploadTab.vue?vue&type=style&index=0&id=6a10d600&scoped=true&lang=css&"
import style1 from "./MyUploadTab.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a10d600",
  null
  
)

export default component.exports